import { defineMessage } from 'services/localization';

export const messages = {
    inviteUsersSuccess: defineMessage('count_plural_one_user_other_users_invited'),
};
